import React, { useRef } from "react";
import styled, { css } from "styled-components";
import { Provider } from "./context";

import { UnderConstruction } from "./components/UnderConstruction";
import { Home } from "./components/Home";

function App() {
  const body = useRef();

  return (
    <div className="App b00" ref={body}>
      <UnderConstruction mobileh mobile />

      {/* <CSSutility><img height='8' src='https://api.netlify.com/api/v1/badges/9b00ad2e-9368-4849-9f57-c5fbc319f766/deploy-status'/></CSSutility> */}
      <Provider>
        <Home />
      </Provider>
    </div>
  );
}

const CSSutility = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1000000;
  display: flex;
  justify-content: flex-end;
`;

export default App;
